import Vue from "vue";
import ElDictSelect from "../components/ElDictSelect/index";
import ElFileUpload from "../components/ElFileUpload/index";
import ElDrawer from "../components/ElDrawer/index";
import ElSelectTree from "../components/ElSelectTree/index";
import ElPanel from "../components/ElPanel/index";
import txUpload from "../components/tx-upload";
import coverUpload from "../components/cover-upload";
import kepingUpload from "../components/keping-upload";
import preAssets from "../components/preAssets";
export default {
  install() {
    Vue.component("el-dict-select", ElDictSelect);
    Vue.component("el-file-upload", ElFileUpload);
    Vue.component("el-drawer", ElDrawer);
    Vue.component("el-select-tree", ElSelectTree);
    Vue.component("el-panel", ElPanel);
    Vue.component("tx-upload", txUpload);
    Vue.component("cover-upload", coverUpload);
    Vue.component("keping-upload", kepingUpload);
    Vue.component("pre-assets", preAssets);
    Vue.mixin({
      methods: {
        rgetDataList() {
          this.pageIndex = 1;
          this.getDataList();
        },
      },
    });
  },
};
